import React from 'react';
import { HOME_THEME as T } from '../../lib/juniorTheme';

interface JuniorHomeHeroProps {
  userName: string;
  animateEntry?: boolean;
}

export const JuniorHomeHero: React.FC<JuniorHomeHeroProps> = ({ userName, animateEntry = false }) => {
  return (
    <header className="mb-10 sm:mb-14">
      <p className="text-base sm:text-lg font-bold" style={{ color: T.muted }}>
        ¡Hola, {userName}!{' '}
        <span className={animateEntry ? 'junior-alive-wave inline-block' : ''} aria-hidden>
          👋
        </span>
      </p>
      <h1
        className="junior-display text-[clamp(2.5rem,7vw,4.25rem)] leading-[1.05] mt-3"
        style={{
          background: T.textGradient,
          WebkitBackgroundClip: 'text',
          color: 'transparent',
        }}
      >
        ¡A jugar con la música!
      </h1>
      <p className="text-base sm:text-lg mt-4 max-w-2xl leading-relaxed font-semibold" style={{ color: T.dim }}>
        Ritmo, melodía, escuchar y mini juegos — todo con colores, sonidos y movimiento.
      </p>
      <div
        className={`inline-flex items-center gap-2 mt-5 px-5 py-2.5 rounded-full text-sm font-extrabold ${animateEntry ? 'junior-alive-block' : ''}`}
        style={{ background: T.accentSoft, color: T.accent }}
      >
        <span aria-hidden>🌈</span>
        Edusico Junior
      </div>
    </header>
  );
};

export default JuniorHomeHero;
